import React from 'react'
import { orderBy } from 'lodash-es'
import './List.css'
import './ProfessionalsList.css'
import { SymbolButton } from '../lib/ui/SymbolButton'
import { formatDbDate } from '../lib/util/formatters'
import { AVProfessionalProject } from "../types/entities";
import { ProfessionalProjectSortables } from "../types/dashboard";
import { routeToPath } from "../routing";

const onSelectContract = (e: React.SyntheticEvent, id: number) => {
  e.stopPropagation()
  routeToPath(`/?page=professional_details&id=${id}`)
}

const onNewContract = (e: React.SyntheticEvent) => {
  e.stopPropagation()
  routeToPath('/?page=professional_details')
}

const DateCell = ({ date }: { date: string }) => {
  return <span>{formatDbDate(date)}</span>
}

interface SortableColumnProps {
  label: string
  property: ProfessionalProjectSortables
  setSorting: Function
}

const SortableColumn = ({ label, property, setSorting }: SortableColumnProps) => {
  return <button
    className='bg-grey white tl-btn-bottom'
    onClick={() => setSorting(property)}>
    {label} ↕
  </button>
}

const containsInsensitive = (string1: string, string2: string): boolean => {
  return string1.toLowerCase().indexOf(string2.toLowerCase()) !== -1
}

interface Props {
  professionals: AVProfessionalProject[] | null
  userProfessionals: AVProfessionalProject[]
  setSorting: Function
  setFiltering: Function
  sorting: any
  filtering: string
}

export const ProfessionalsList = (props: Props) => {
  const { professionals, sorting, filtering, setSorting, setFiltering } = props
  if (!professionals) {
    return <div>Loading professionals...</div>
  }

  const filtered = professionals.filter(professionals =>
    !filtering || containsInsensitive(professionals.LastName, filtering) || containsInsensitive(professionals.FirstName, filtering))
  const userProfessionals = orderBy(filtered, [sorting.property], [sorting.order])

  return <div className='lst-container cl-container'>
    <div className='white bg-grey head'>
      Professionals ({professionals.length})
      <SymbolButton
        className='float-right'
        icon='asterisk'
        onClick={(e: React.SyntheticEvent) => onNewContract(e)}
      />
    </div>
    <div className='white bg-grey head'>
      <input
        onChange={e => setFiltering(e.target.value)}
        id='contractsFilter'
        autoComplete='off'
        value={filtering}
        style={{width: '93%', marginBottom: '3px', padding: '2px'}} />
      <SymbolButton
        className='embed-left'
        icon='cross-grey'
        onClick={() => setFiltering('')}
      />
    </div>
    <table cellSpacing='0'>
      <thead>
        <tr>
          <th className='small'>
            <SortableColumn
              label='Professional'
              property='LastName'
              setSorting={setSorting}
            />
          </th>
          <th className='small'>
            <SortableColumn
              label='Project Code'
              property='CodeAV'
              setSorting={setSorting}
            />
          </th>
          <th className='small'>
            <SortableColumn
              label='Start date'
              property='StartDate'
              setSorting={setSorting}
            />
          </th>
          <th className='small'>
            <SortableColumn
              label='End date'
              property='EndDate'
              setSorting={setSorting}
            />
          </th>
          <th className='small open-tasks'>
            Reimbursed
          </th>
          <th className='small open-tasks'>
            Deductible
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {userProfessionals.map(professional => {
          const key = `${professional.ID}_${professional.PRJID}`
          return <tr
            className='contract-row'
            key={key}
            onClick={(e: React.SyntheticEvent) => onSelectContract(e, professional.ID)}>
            <td>
              {professional.LastName}, {professional.FirstName}
            </td>
            <td>
              {professional.ProjectCode}
            </td>
            <td className='birth-date'>
              {professional.StartDate && <DateCell date={professional.StartDate} />}
            </td>
            <td className='end-date'>
              {professional.EndDate && <DateCell date={professional.EndDate} />}
            </td>
            <td className='open-tasks'>
              {professional.PRJID && professional.ExpensesReimbursed ? 'Exp ' : ''}
              {professional.PRJID && professional.TravelReimbursed ? 'KM' : ''}
            </td>
            <td className='open-tasks'>
              {professional.PRJID && professional.TravelDeductible ? 'KM ' : ''}
              {professional.PRJID && professional.TravelExpensesDeductible ? 'TrvExp ' : ''}
              {professional.PRJID && professional.ExpensesDeductible ? 'OthExp' : ''}
            </td>
            <td style={{width: 30}}>
            </td>
          </tr>
        })}
      </tbody>
    </table>
  </div>
}